// extracted by mini-css-extract-plugin
export default {"root":"IconSort_root__72IYb"};